/* Cart Drawer Gift — logique JS externalisée (v2 multipliers x1/x2/x3)
 * S'abonne à PUB_SUB_EVENTS.cartUpdate (Dawn) pour rejouer
 * la logique add/remove à chaque update du panier.
 *
 * Patterns :
 * - Mode "choice" : click sur AJOUTER → POST /cart/add.js (un cadeau à la fois)
 * - Mode "auto"   : ajoute le 1er cadeau si seuil atteint et pas déjà présent
 * - Mode "multi"  : sync qty cadeau = somme(qty item × multiplier produit)
 * - Toujours     : retire le cadeau si threshold_reached devient false
 */

(function() {
  'use strict';

  var ENDPOINT_CART = '/cart.js';
  var ENDPOINT_ADD = '/cart/add.js';
  var ENDPOINT_CHANGE = '/cart/change.js';

  // Anti-double-trigger : flag global pour éviter loops
  var processing = false;
  // Queue : si un event cartUpdate arrive pendant qu'on traite, on retry après
  var pendingSync = false;
  // Debounce du cartUpdate listener (évite cascade de mutations sur events rapides)
  var debounceTimer = null;
  var DEBOUNCE_MS = 150;

  function lockEligibleItems() {
    // Lock visuel de tous les items non-cadeau pendant la mutation crayon.
    // Le refresh du drawer ré-écrit le DOM = unlock auto.
    var items = document.querySelectorAll('.cart-item-grille:not(.cart-item-grille--gift)');
    for (var i = 0; i < items.length; i++) {
      items[i].setAttribute('data-eligible-locked', '1');
    }
  }

  function fetchCart() {
    return fetch(ENDPOINT_CART, { credentials: 'same-origin' }).then(function(r) { return r.json(); });
  }

  function changeQty(key, qty) {
    return fetch(ENDPOINT_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r) { return r.json(); });
  }

  function addItem(variantId, qty) {
    var quantity = qty && qty > 0 ? qty : 1;
    return fetch(ENDPOINT_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity, properties: { '_gift': 'true' } }]
      })
    }).then(function(r) { return r.json(); });
  }

  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      return fetch('/?sections=cart-drawer,cart-icon-bubble,cart-live-region-text')
        .then(function(r) { return r.json(); })
        .then(function(sections) { drawer.renderContents({ sections: sections }); });
    }
    return Promise.resolve();
  }

  function findGiftLineKey(cart, giftVariantIds) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var prop = item.properties && (item.properties._gift === 'true' || item.properties._gift === true);
      if (prop) return item.key;
      if (giftVariantIds.indexOf(item.variant_id) !== -1) return item.key;
    }
    return null;
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    btn.classList.toggle('cart-drawer-gift__btn--loading', loading);
    btn.disabled = loading;
  }

  function parseMultipliers(raw) {
    // Parse "id1:1,id2:2,id3:3" → { id1: 1, id2: 2, id3: 3 }
    var map = {};
    if (!raw) return map;
    var pairs = raw.split(',');
    for (var i = 0; i < pairs.length; i++) {
      var p = pairs[i].split(':');
      if (p.length === 2) {
        var id = parseInt(p[0], 10);
        var mult = parseInt(p[1], 10);
        if (id && mult > 0) {
          // Si déjà set, garder la valeur la plus haute (priorité x3 > x2 > x1)
          if (!map[id] || mult > map[id]) map[id] = mult;
        }
      }
    }
    return map;
  }

  function getGiftConfig() {
    var section = document.querySelector('[data-cart-gift]');
    if (!section) return null;
    var ids = (section.dataset.giftVariantIds || '').split(',').filter(Boolean).map(function(v) { return parseInt(v, 10); });
    var eligibleIds = (section.dataset.eligibleProductIds || '').split(',').filter(Boolean).map(function(v) { return parseInt(v, 10); });
    var multipliers = parseMultipliers(section.dataset.eligibleMultipliers || '');
    return {
      element: section,
      mode: section.dataset.mode,
      thresholdReached: section.dataset.thresholdReached === 'true',
      eligibleQuantity: parseInt(section.dataset.eligibleQuantity, 10) || 0,
      eligibleFilterEnabled: section.dataset.eligibleFilterEnabled === 'true',
      eligibleProductIds: eligibleIds,
      eligibleMultipliers: multipliers,
      giftVariantIds: ids,
      autoplay: parseInt(section.dataset.autoplay, 10) || 0
    };
  }

  // Calcule la qty éligible LIVE depuis l'état réel du cart (pas le data-attribute stale)
  // Applique le multiplicateur par produit : 1 cahier ×1 = 1 cadeau, 1 pack ×2 = 2 cadeaux
  function computeEligibleQty(cart, config) {
    if (!cart || !cart.items) return 0;
    var qty = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var isGift = item.properties && (item.properties._gift === 'true' || item.properties._gift === true);
      if (isGift) continue;
      // Aussi exclure si c'est l'un des produits cadeau configurés (au cas où une line n'a pas la property)
      if (config.giftVariantIds.indexOf(item.variant_id) !== -1) continue;

      var multiplier = 0;
      if (!config.eligibleFilterEnabled) {
        multiplier = 1; // pas de filtre = tout compte ×1
      } else if (config.eligibleMultipliers[item.product_id]) {
        multiplier = config.eligibleMultipliers[item.product_id];
      } else if (config.eligibleProductIds.indexOf(item.product_id) !== -1) {
        multiplier = 1; // fallback si dans la liste mais pas dans la map
      }

      if (multiplier > 0) qty += item.quantity * multiplier;
    }
    return qty;
  }

  // ===== Cleanup : retire un cadeau orphelin si seuil non atteint OU panier vide =====
  function runCleanup() {
    if (processing) return Promise.resolve();
    var config = getGiftConfig();

    return fetchCart().then(function(cart) {
      // Pas de section présente OU section présente mais seuil non atteint → retirer cadeau si présent
      var giftIds = config ? config.giftVariantIds : [];
      // Toujours essayer de récupérer la config "static" via les setting attributes même si section absente
      // (fallback : si section pas dans le DOM, on n'a pas la liste des variants → on ne fait rien)
      if (giftIds.length === 0) return null;

      var existingKey = findGiftLineKey(cart, giftIds);
      if (!existingKey) return null;

      var shouldRemove = !config || !config.thresholdReached || cart.item_count <= 1;
      // ↑ item_count <= 1 signifie : il ne reste que le cadeau dans le panier (cas du "vider le panier")
      if (cart.item_count === 1 && cart.items[0] && cart.items[0].key === existingKey) {
        shouldRemove = true;
      }
      if (!shouldRemove) return null;

      processing = true;
      return changeQty(existingKey, 0).then(refreshCartDrawer).finally(function() {
        processing = false;
      });
    }).catch(function(err) {
      processing = false;
      console.error('[cart-gift] cleanup error:', err);
    });
  }

  // ===== Mode MULTI : synchronise la quantité du cadeau avec le nb d'items éligibles =====
  // 3 cahiers Culture → 3 crayons offerts. 2 cahiers → 2 crayons. 0 → 0.
  function runMultiSync() {
    if (processing) {
      // Une sync est déjà en cours : marquer qu'on doit re-sync après pour rattraper le nouveau state
      pendingSync = true;
      return Promise.resolve();
    }
    var config = getGiftConfig();
    if (!config || config.mode !== 'multi') return Promise.resolve();
    if (config.giftVariantIds.length === 0) return Promise.resolve();

    return fetchCart().then(function(cart) {
      // Calcul LIVE depuis le cart actuel — évite stale data-eligible-quantity
      var targetQty = computeEligibleQty(cart, config);

      var existingLine = null;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var isGift = item.properties && (item.properties._gift === 'true' || item.properties._gift === true);
        if (isGift) { existingLine = item; break; }
        // Fallback : matche aussi par variant_id si la property a été perdue
        if (config.giftVariantIds.indexOf(item.variant_id) !== -1) { existingLine = item; break; }
      }
      var currentQty = existingLine ? existingLine.quantity : 0;
      if (currentQty === targetQty) return null;

      processing = true;
      lockEligibleItems();
      var promise;
      if (targetQty <= 0 && existingLine) {
        promise = changeQty(existingLine.key, 0);
      } else if (existingLine) {
        promise = changeQty(existingLine.key, targetQty);
      } else {
        promise = addItem(config.giftVariantIds[0], targetQty);
      }
      return promise.then(refreshCartDrawer).finally(function() {
        processing = false;
        // Si un autre event est arrivé pendant qu'on traitait, re-sync pour rattraper
        if (pendingSync) {
          pendingSync = false;
          setTimeout(init, 50);
        }
      });
    }).catch(function(err) {
      processing = false;
      if (pendingSync) {
        pendingSync = false;
        setTimeout(init, 100);
      }
      console.error('[cart-gift] multi-sync error:', err);
    });
  }

  // ===== Mode AUTO : ajoute le 1er cadeau si seuil atteint et pas déjà présent =====
  function runAutoAdd() {
    if (processing) return Promise.resolve();
    var config = getGiftConfig();
    if (!config || config.mode !== 'auto' || !config.thresholdReached) return Promise.resolve();
    if (config.giftVariantIds.length === 0) return Promise.resolve();

    return fetchCart().then(function(cart) {
      var existingKey = findGiftLineKey(cart, config.giftVariantIds);
      if (existingKey) return null; // déjà un cadeau
      processing = true;
      return addItem(config.giftVariantIds[0]).then(refreshCartDrawer).finally(function() {
        processing = false;
      });
    }).catch(function(err) {
      processing = false;
      console.error('[cart-gift] auto-add error:', err);
    });
  }

  // ===== Mode CHOICE : click sur AJOUTER =====
  function bindChoiceButtons() {
    var config = getGiftConfig();
    if (!config || config.mode !== 'choice') return;
    var buttons = config.element.querySelectorAll('[data-gift-add-btn]');
    buttons.forEach(function(btn) {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function() {
        var variantId = parseInt(btn.dataset.variantId, 10);
        if (!variantId || btn.disabled || processing) return;
        setLoading(btn, true);
        processing = true;

        fetchCart().then(function(cart) {
          var existingKey = findGiftLineKey(cart, config.giftVariantIds);
          var sameAsActive = false;
          if (existingKey) {
            cart.items.forEach(function(it) {
              if (it.key === existingKey && it.variant_id === variantId) sameAsActive = true;
            });
          }
          if (sameAsActive) {
            return changeQty(existingKey, 0);
          }
          var chain = Promise.resolve();
          if (existingKey) chain = chain.then(function() { return changeQty(existingKey, 0); });
          return chain.then(function() { return addItem(variantId); });
        }).then(refreshCartDrawer).catch(function(err) {
          console.error('[cart-gift] add error:', err);
        }).finally(function() {
          processing = false;
          setLoading(btn, false);
        });
      });
    });
  }

  // ===== Autoplay carrousel mode choice =====
  var autoplayTimer = null;
  function bindAutoplay() {
    if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
    var config = getGiftConfig();
    if (!config || config.mode !== 'choice' || config.autoplay <= 0) return;
    var slider = config.element.querySelector('[data-gift-slider]');
    if (!slider) return;
    var cards = slider.querySelectorAll('[data-gift-card]');
    if (cards.length <= 1) return;
    var idx = 0;
    autoplayTimer = setInterval(function() {
      if (!document.body.contains(config.element)) { clearInterval(autoplayTimer); autoplayTimer = null; return; }
      idx = (idx + 1) % cards.length;
      cards[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }, config.autoplay * 1000);
    config.element.addEventListener('mouseenter', function() {
      if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
    }, { once: true });
  }

  // ===== Initialize on cart update event + on first load =====
  function init() {
    bindChoiceButtons();
    bindAutoplay();
    var config = getGiftConfig();
    if (config && config.mode === 'multi') {
      runMultiSync();
    } else {
      runCleanup().then(runAutoAdd);
    }
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function scheduleSync() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      debounceTimer = null;
      init();
    }, DEBOUNCE_MS);
  }

  // Hook 1 : Dawn pub/sub (couvre product-form.js Dawn natif, cart.js)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
  }

  // Hook 2 : patch cart-drawer renderContents pour capturer les flows custom
  // qui ne publient pas PUB_SUB_EVENTS.cartUpdate (featured-collection quick add,
  // sticky-mobile-buy-bar, related-products, cart-drawer-upsell, etc.).
  // Tous appellent cart-drawer.renderContents() après leur fetch /cart/add.js.
  function patchCartDrawerRender() {
    if (typeof customElements === 'undefined') return;
    var CartDrawerClass = customElements.get('cart-drawer');
    if (!CartDrawerClass || !CartDrawerClass.prototype) return;
    if (CartDrawerClass.prototype._giftSyncPatched) return;
    var original = CartDrawerClass.prototype.renderContents;
    if (typeof original !== 'function') return;
    CartDrawerClass.prototype.renderContents = function() {
      var result = original.apply(this, arguments);
      scheduleSync();
      return result;
    };
    CartDrawerClass.prototype._giftSyncPatched = true;
  }

  // Le custom element peut être défini après notre script (timing defer).
  // On retry si pas encore prêt, max 10 tentatives sur 1 seconde.
  var patchAttempts = 0;
  function tryPatch() {
    var CartDrawerClass = (typeof customElements !== 'undefined') && customElements.get('cart-drawer');
    if (CartDrawerClass && CartDrawerClass.prototype) {
      patchCartDrawerRender();
    } else if (patchAttempts++ < 10) {
      setTimeout(tryPatch, 100);
    }
  }
  tryPatch();
})();
